import * as React from 'react';

type SpacerType = React.HTMLAttributes<HTMLSpanElement> & {
  axis: 'horizontal' | 'vertical';
  size?: number | string;
};

export const Spacer = React.forwardRef<HTMLSpanElement, SpacerType>(
  ({ size, axis, style = {}, ...delegated }, ref) => {
    const width = axis === 'vertical' ? 1 : size;
    const height = axis === 'horizontal' ? 1 : size;

    return (
      <span
        style={{
          display: 'block',
          width,
          minWidth: width,
          height,
          minHeight: height,
          ...style,
        }}
        {...delegated}
        ref={ref}
      />
    );
  }
);
